import CommomProxy from '@/components/proxy/CommomProxy'

let child_routes = [{
        path: 'index',
        name: 'index',
        component: resolve => {
            require(['@/views/pay/index.vue'], resolve);
        },
        meta: {
            title: '支付'
        }
    },
    {
        path: 'hIndex',
        name: 'hIndex',
        component: resolve => {
            require(['@/views/pay/hIndex.vue'], resolve);
        },
        meta: {
            title: '支付'
        }
    },
    {
        path: 'success',
        name: 'success',
        component: resolve => {
            require(['@/views/pay/success.vue'], resolve);
        },
        meta: {
            title: '支付结果'
        }
    },
    {
        path: 'cash',
        name: 'cash',
        component: resolve => {
            require(['@/views/pay/cash.vue'], resolve);
        },
        meta: {
            title: '收银台'
        }
    },
    {
        path: 'payStatus',
        name: 'payStatus',
        component: resolve => {
            require(['@/views/pay/payStatus.vue'], resolve);
        },
        meta: {
            title: '支付详情'
        }
    },
    {
        path: 'text',
        name: 'text',
        component: resolve => {
            require(['@/views/pay/text.vue'], resolve);
        },
        meta: {
            title: '测试页面'
        }
    }

]

let route = [{
    path: '/pay',
    component: CommomProxy,
    children: child_routes
}]

export default route



// WEBPACK FOOTER //
// ./src/router/pay.js